import { useIntl } from 'lib/intl-utils'
import { c, FC } from 'lib/component-utils'
import Container from 'components/landing/Container'
import BrandImage from 'components/landing/BrandImage'

const logos = [
  { name: 'naos', description: 'Naos', className: 'h-7' },
  { name: 'bkcosmetic', description: 'Белорусская косметика', className: 'h-9' },
  { name: 'kitfort', description: 'Kitfort', className: 'h-7' },
  { name: 'nivea', description: 'NIVEA', className: 'h-14' },
  { name: 'loreal', description: "L'Oréal", className: 'h-6' },
  { name: 'tervolina', description: 'Tervolina', className: 'h-6' },
  { name: 'shik', description: 'Shik', className: 'h-9' },
  { name: 'snowqueen', description: 'Снежная Королева', className: 'h-6' },
  { name: 'barrier', description: 'Барьер', className: 'h-9' },
  { name: 'borjomi', description: 'Borjomi', className: 'h-6' },
  { name: 'veiro', description: 'Veiro', className: 'h-9' },
]

const SellersLogos: FC = ({ className }) => {
  const { t } = useIntl()

  return (
    <Container className={c`${className}`}>
      <h2 className="text-3xl font-medium text-left">{t`landing.already_working_with_us`}</h2>
      <ul
        role="list"
        className="flex flex-row flex-wrap items-center justify-start gap-10 mt-10 xl:gap-12"
      >
        {logos.map(({ name, description, className }) => (
          <li key={name} className="flex justify-center w-fit">
            <BrandImage name={name} description={description} className={className} />
          </li>
        ))}
      </ul>
    </Container>
  )
}

export default SellersLogos
